/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import route from '../../../../assets/icons/route.svg';
import clock from '../../../../assets/icons/Clock.svg';
import deviation from '../../../../assets/icons/Deviation.svg';
import check from '../../../../assets/icons/check.svg';
import infoIcon from '../../../../assets/icons/i.svg';
import { title } from 'process';
import { IconButton } from '@mui/material';
import { useRouteContext } from 'packages/novous_web/src/context/RouteContext';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import PermissionGuard from '../../../../common/components/PermissionGuard';
import { PermissionSubcategory } from '../../../../utils/permissionConstants';
type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const RouteDataTiles: React.FC<{ data: ColumnObjType | undefined }> = ({ data }) => {
  const { user } = useAuth();
  const [countData, setCountData] = useState<any>();
  const {
    data: routeCountData,
    error: routeCountError,
    loading: routeCountLoading,
    fetchData: fetchRouteCountData,
  } = useAxios<any>(`${API_ENDPOINTS.dashboard.GET_ROUTE_COUNT}/${user?.customer_id}`, 'GET');

  useEffect(() => {
    fetchRouteCountData();
  }, [user]);

  useEffect(() => {
    setCountData(routeCountData);
  }, [routeCountData]);
  let tripTilesData = [
    {
      icon: route,
      heading: 'Total Routes',
      value: countData?.data?.totalRoute,
      permission: {
        category: PermissionSubcategory.ROUTES,
        subcategory: PermissionSubcategory.TOTAL_ROUTES,
      },
    },
    {
      icon: clock,
      heading: 'Scheduled Routes',
      value: countData?.data?.scheduledRoute,
      permission: {
        category: PermissionSubcategory.ROUTES,
        subcategory: PermissionSubcategory.SCHEDULED_ROUTES,
      },
    },
    {
      icon: deviation,
      heading: 'Deviated Routes',
      value: countData?.data?.deviatedRoute,
      permission: {
        category: PermissionSubcategory.ROUTES,
        subcategory: PermissionSubcategory.DEVIATED_ROUTES,
      },
    },
    {
      icon: check,
      heading: 'Unused Routes',
      value: countData?.data?.unusedRoute,
      permission: {
        category: PermissionSubcategory.ROUTES,
        subcategory: PermissionSubcategory.UNUSED_ROUTES,
      },
    },
  ];

  const filteredTileData = useMemo(() => {
    return tripTilesData.filter((item, index) => {
      const stateName = 'Stat' + (index + 1);
      if (data) {
        if (data[stateName].name === item.heading) {
          return data[stateName].status;
        }
        return false;
      } else {
        return true;
      }
    });
  }, [data, tripTilesData]);

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {filteredTileData.map((tile, index) => (
        <PermissionGuard
          key={index}
          category={tile.permission.category}
          subcategory={tile.permission.subcategory}
        >
          <Paper
            sx={{ borderRadius: '12px' }}
            className="border border-[#f0eff8] p-4 flex flex-col gap-1 items-start"
          >
            <div className="flex items-center gap-2 w-full">
              <IconButton
                sx={(theme) => ({
                  background: theme.palette.selected,
                  padding: '4px',
                })}
              >
                <img src={tile?.icon} alt="icon" color="primary" />
              </IconButton>
              <div className="flex flex-1 min-w-0 flex-col justify-start gap-1">
                <Typography
                  variant="body2"
                  noWrap // Ensures text doesn't wrap and remains in a single line
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%', // Ensures it adapts to available space
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '24px',
                  }}
                >
                  {tile.heading}
                </Typography>
              </div>

              <img src={infoIcon} alt="info icon" title="More info" className="w-4 h-4 cursor-pointer" />
            </div>
            <div className="flex items-center w-full gap-2 flex-nowrap">
              <div className="invisible w-6 h-6">{tile.icon}</div>
              <Typography
                variant="h6"
                fontWeight={600}
                className="flex-grow px-2 w-full whitespace-nowrap overflow-hidden text-ellipsis"
              >
                {tile.value}
              </Typography>
            </div>
          </Paper>
        </PermissionGuard>
      ))}
    </div>
  );
};

export default RouteDataTiles;
